// extracted by mini-css-extract-plugin
export default {"stepperRoot":"MergeUsers_stepperRoot__PPEtq","tableWrapper":"MergeUsers_tableWrapper__AhziG","tableCell":"MergeUsers_tableCell__Cw8v0"};